import React from 'react'
const InformationPopup = (props) => {
    const {title, info} = props;
    return (
        <>
            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-250px' data-sai-menu='true'>
                <div className="row p-5">
                    <div className="col-md-12 mb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <h5>
                                    {title}
                                </h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <span className="fw-semibold text-gray-600 fs-6 d-block">
                                    {info}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InformationPopup